export const publicFacilitiesVocabulary = [
  {
    word: "Retrieve",
    meaning: "찾다, 회수하다",
    audioId: 1,
  },
  {
    word: "Passenger",
    meaning: "승객, 탑승객",
    audioId: 2,
  },
  {
    word: "Handrail",
    meaning: "손잡이, 난간",
    audioId: 3,
  },
  {
    word: "Boarding",
    meaning: "탑승",
    audioId: 4,
  },
  {
    word: "Depart",
    meaning: "출발하다",
    audioId: 5,
  },
  {
    word: "Approach",
    meaning: "다가오다, 접근하다",
    audioId: 6,
  },
  {
    word: "Luggage",
    meaning: "수하물, 짐",
    audioId: 7,
    imageUrl: "/images/vocabulary/public/public7.png",
  },
  {
    word: "Baggage Claim Area",
    meaning: "수하물 찾는 곳",
    audioId: 8,
  },
  {
    word: "Suitcase",
    meaning: "여행 가방",
    audioId: 9,
  },
  {
    word: "Mount",
    meaning: "설치하다, 부착하다",
    audioId: 10,
  },
  {
    word: "Aircraft",
    meaning: "항공기",
    audioId: 11,
  },
  {
    word: "Landing",
    meaning: "착륙",
    audioId: 12,
    imageUrl: "/images/vocabulary/public/public12.png",
  },
  {
    word: "Taking off",
    meaning: "이륙하다",
    audioId: 13,
    imageUrl: "/images/vocabulary/public/public13.png",
  },
  {
    word: "Runway",
    meaning: "활주로",
    audioId: 14,
  },
  {
    word: "Pedestrian",
    meaning: "보행자",
    audioId: 15,
  },
  {
    word: "Median Barrier",
    meaning: "중앙 분리대",
    audioId: 16,
    imageUrl: "/images/vocabulary/public/public16.png",
  },
  {
    word: "Intersection",
    meaning: "교차로",
    audioId: 17,
    imageUrl: "/images/vocabulary/public/public17.png",
  },
  {
    word: "Roadside",
    meaning: "길가, 도로변",
    audioId: 18,
  },
  {
    word: "Highway",
    meaning: "고속도로",
    audioId: 19,
  },
  {
    word: "Bushes",
    meaning: "관목, 덤불",
    audioId: 20,
    imageUrl: "/images/vocabulary/public/public20.png",
  },
  {
    word: "Trim",
    meaning: "다듬다, 손질하다",
    audioId: 21,
  },
  {
    word: "Street Lamp",
    meaning: "가로등(빛을 내는 등 자체)",
    audioId: 22,
    imageUrl: "/images/vocabulary/public/public22.png",
  },
  {
    word: "Pathway",
    meaning: "보도, 통로",
    audioId: 23,
  },
  {
    word: "Lamp Post",
    meaning: "가로등 기둥(조명을 지탱하는 기둥 포함 전체 구조)",
    audioId: 24,
    imageUrl: "/images/vocabulary/public/public24.png",
  },
  {
    word: "Fountain",
    meaning: "분수",
    audioId: 25,
  },
  {
    word: "Span",
    meaning: "뻗어있다, 걸쳐있다",
    audioId: 26,
  },
  {
    word: "Plow",
    meaning: "밭을 갈다",
    audioId: 27,
    imageUrl: "/images/vocabulary/public/public27.png",
  },
  {
    word: "Windmill",
    meaning: "풍차",
    audioId: 28,
  },
  {
    word: "Pasture",
    meaning: "목초지, 방목장",
    audioId: 29,
    imageUrl: "/images/vocabulary/public/public29.png",
  },
  {
    word: "Graze",
    meaning: "풀을 뜯어먹다, 방목하다",
    audioId: 30,
  },
  {
    word: "Barn",
    meaning: "헛간, 외양간",
    audioId: 31,
    imageUrl: "/images/vocabulary/public/public31.png",
  },
  {
    word: "Street Performer",
    meaning: "거리 공연가",
    audioId: 32,
  },
  {
    word: "Statue",
    meaning: "조각상",
    audioId: 33,
  },
  {
    word: "Monument",
    meaning: "기념비, 기념물",
    audioId: 34,
    imageUrl: "/images/vocabulary/public/public34.png",
  },
  {
    word: "Square",
    meaning: "광장",
    audioId: 35,
  },
  {
    word: "Plaza",
    meaning: "플라자, 광장",
    audioId: 36,
    imageUrl: "/images/vocabulary/public/public36.png",
  },
  {
    word: "Railroad",
    meaning: "철도, 철로",
    audioId: 37,
  },
  {
    word: "Vessel",
    meaning: "선박, 배",
    audioId: 38,
  },
  {
    word: "Compartment",
    meaning: "칸, 구획",
    audioId: 39,
  },
  {
    word: "Shed",
    meaning: "헛간, 창고",
    audioId: 40,
    imageUrl: "/images/vocabulary/public/public40.png",
  },
  {
    word: "Chopping",
    meaning: "자르기, 썰기, 절단하기",
    audioId: 41,
  },
  {
    word: "Pavement",
    meaning: "포장도로, 보도",
    audioId: 42,
  },
  {
    word: "Structure",
    meaning: "구조물, 건물",
    audioId: 43,
  },
  {
    word: "Stream",
    meaning: "시냇물, 개울",
    audioId: 44,
  },
  {
    word: "Pillar",
    meaning: "기둥, 지주",
    audioId: 45,
  },
  {
    word: "Treadmill",
    meaning: "러닝머신",
    audioId: 46,
  },
  {
    word: "Easel",
    meaning: "이젤",
    audioId: 47,
    imageUrl: "/images/vocabulary/public/public47.png",
  },
  {
    word: "Tripod",
    meaning: "삼각대",
    audioId: 48,
  },
  {
    word: "Mow",
    meaning: "잔디를 깎다",
    audioId: 49,
  },
  {
    word: "Pier",
    meaning: "부두, 선착장",
    audioId: 50,
  },
  {
    word: "Log",
    meaning: "통나무",
    audioId: 51,
  },
  {
    word: "Cabin",
    meaning: "오두막집",
    audioId: 52,
  },
  {
    word: "Unattended",
    meaning: "방치된, 무인의",
    audioId: 53,
  },
  {
    word: "Cross from each other",
    meaning: "서로 마주보고 있는",
    audioId: 54,
  },
  {
    word: "Disembark",
    meaning: "하선하다, 내리다",
    audioId: 55,
  },
  {
    word: "Stroll",
    meaning: "산책하다",
    audioId: 56,
  },
  {
    word: "Watering Can",
    meaning: "물뿌리개",
    audioId: 57,
  },
  {
    word: "Branch",
    meaning: "나뭇가지",
    audioId: 58,
  },
  {
    word: "Rake",
    meaning: "갈퀴",
    audioId: 59,
  },
  {
    word: "Harbor",
    meaning: "항구",
    audioId: 60,
  },
  {
    word: "Port",
    meaning: "항구",
    audioId: 61,
  },
  {
    word: "Dock",
    meaning: "부두",
    audioId: 62,
  },
  {
    word: "Anchor",
    meaning: "정박하다",
    audioId: 63,
  },
  {
    word: "Sail",
    meaning: "항해하다",
    audioId: 64,
  },
  {
    word: "Reflect",
    meaning: "반사되다",
    audioId: 65,
  },
];
